<template>
    <transition name="fade">
        <div class="modal is-active" v-show="visible">
            <div class="modal-background" @click="destroy"></div>

            <g-form :action="`/api/user/email`"
                    :form="form"
                    :loading="isLoading"
                    @loading-state="(state) => isLoading = state"
                    @success="onSuccess"
                    :before="beforeSubmit"
            >
                <div class="modal-content">
                    <div class="popup-dialog">
                        <div class="popup-title">
                            <h1 class="title is-1">{{ $t('account.email_change.title') }}</h1>

                            <div class="popup-close" @click.prevent="destroy">
                                <i class="icon">close</i>
                            </div>
                        </div>

                        <div class="popup-body popup-body-bottom-border">
                            <p>{{ $t('account.email_change.description') }}</p>
                        </div>

                        <div class="popup-body popup-rows">
                            <div class="columns">
                                <div class="column is-one-third">
                                    <label>{{ $t('account.email_change.email_new') }}</label></div>
                                <div class="column">
                                    <g-input name="email" type="email" autocomplete="email"
                                             :label="$t('account.email_change.email_new_label')"/>
                                </div>
                            </div>
                        </div>

                        <div class="popup-footer">
                            <a @click.prevent="destroy" href="#" role="button">{{ $t('submit_dialog.cancel') }}</a>
                            <g-button :loading="isLoading" :disabled="isDisabled">{{
                                    $t('submit_dialog.submit')
                                }}
                            </g-button>
                        </div>
                    </div>
                </div>
            </g-form>
        </div>
    </transition>
</template>

<script>
import Form from "../../../../utils/Form";

export default {
    data() {
        return {
            isLoading: false,
            isDisabled: true,
            form: new Form({
                email: '',
            })
        }
    },
    watch: {
        'form.email'(value, old) {
            if (!value || value.length < 5) {
                this.isDisabled = true
                return
            }

            this.isDisabled = false
        },
    },
    methods: {
        /**
         * Before asking for the email change, we validate if this email would be valid and is not already taken
         */
        async beforeSubmit(form) {
            try {
                await axios.post('/api/user/email/validate', {
                    email: form.email
                })

                return form
            } catch (error) {
                // Validation errors will be handled by g-form component
                if (error.response && error.response.status === 422) {
                    this.form.setErrors(error.response.data.errors)

                    this.$buefy.toast.open({
                        message: error.response.data.message.charAt(0).toUpperCase() + error.response.data.message.slice(1),
                        type: 'is-danger',
                    })
                }

                // Stop the form submission
                return false
            }
        },
        /**
         * Show the verification popup for the new email
         */
        onSuccess(response) {
            // Check if the response indicates pending verification for new email
            if (response.status === 'pending_verification') {
                const {token, type, methods, new_email, title, instructions, expires_at} = response

                // Show verification popup for the new email
                return this.showNewEmailVerification(token, type, methods, new_email, title, instructions, expires_at)
            }

            // We are always expecting a verification request, but handle gracefully if not
            console.warn('Did not receive expected pending_verification response after email change request', response)

            this.destroy()
        },
        /**
         * Show the email verification popup for the new email
         */
        showNewEmailVerification(token, type, methods, newEmail, title, instructions, expiresAt) {
            this.$popup('VerificationCodeInput', {
                verificationType: type,
                methods: methods,
                endpoints: {
                    verify: '/api/user/email/verify',
                    resend: '/api/user/email/resend',
                },
                title: title,
                instructions: instructions,
                expiresAt: expiresAt,
                context: {
                    token: token,
                    new_email: newEmail
                },
                onVerified: () => {
                    console.log('New email verified', newEmail)

                    // Close this email change component
                    this.destroy({
                        success: true,
                        new_email: newEmail,
                    })
                },
                onCancel: () => {
                    // User cancelled new email verification
                }
            })
        },
    },
}
</script>
